import { useState, useRef, ReactNode } from 'react';

interface ChatDropZoneProps {
  children: ReactNode;
  onFilesDropped: (files: File[]) => void;
  disabled?: boolean;
}

export function ChatDropZone({ children, onFilesDropped, disabled = false }: ChatDropZoneProps) {
  const [isDragging, setIsDragging] = useState(false);
  const dragCounterRef = useRef(0);

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (disabled) return;
    
    dragCounterRef.current++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setIsDragging(true);
    }
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (disabled) return;
    
    dragCounterRef.current--;
    if (dragCounterRef.current === 0) {
      setIsDragging(false);
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    console.log('💧 ChatDropZone - Drop detectado');
    
    if (disabled) {
      console.log('⚠️ ChatDropZone - Drop ignorado (disabled)');
      return;
    }
    
    setIsDragging(false);
    dragCounterRef.current = 0;

    const files = Array.from(e.dataTransfer.files);
    console.log('📁 ChatDropZone - Arquivos capturados:', files.map(f => f.name));
    
    if (files.length > 0) {
      onFilesDropped(files);
    }
  };

  return (
    <div
      className="relative h-full w-full"
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      {/* Overlay de Drag and Drop */}
      {isDragging && (
        <div className="absolute inset-0 bg-blue-600/5 backdrop-blur-[2px] z-50 flex items-center justify-center animate-in fade-in duration-150">
          <div className="relative">
            {/* Borda animada */}
            <div className="absolute inset-0 border-2 border-dashed border-blue-600/30 rounded-xl animate-pulse" 
                 style={{ width: '400px', height: '200px' }} />
            
            {/* Conteúdo */}
            <div className="relative bg-white/95 backdrop-blur-md rounded-xl shadow-lg border border-gray-200/50 p-8 flex flex-col items-center justify-center"
                 style={{ width: '400px', height: '200px' }}>
              
              {/* Ícone minimalista */}
              <div className="mb-4 relative">
                <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                  </svg>
                </div>
              </div>
              
              {/* Texto principal */}
              <p className="text-base font-medium text-gray-900 mb-1">Solte para anexar</p>
              <p className="text-sm text-gray-500">Suporta múltiplos arquivos</p>
            </div>
          </div>
        </div>
      )}

      {children}
    </div>
  );
}
